import React from 'react';

/**
 * Pakistani Rupee (₨ / Rs) stroke icon matching Feather Icons' 24x24 geometry.
 */
const PkrIcon = ({ size = '1em', className = '', style, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    style={style}
    {...props}
  >
    <path d="M3.5 19V5h4.5a3.5 3.5 0 0 1 0 7H3.5" />
    <path d="M7.5 12L11.5 19" />
    <path d="M20 12c-.4-1-1.3-1.5-2.5-1.5-1.5 0-2.6.8-2.6 2 0 1.3 1.2 1.7 2.6 2.1 1.5.4 2.7.9 2.7 2.3 0 1.3-1.2 2.1-2.8 2.1-1.3 0-2.3-.5-2.8-1.5" />
  </svg>
);

export default PkrIcon;
